import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-fees-create',
  templateUrl: './fees-create.component.html',
  styleUrls: ['./fees-create.component.scss']
})
export class FeesCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  coursename = null;
  submitted = false;
  public feesForm: FormGroup;
  public courses = [];
  /* public addinputs: any[] = [{
    dtution: '',
    dacademic: '',
    dtotal: '',
    itution: '',
    iacademic: '',
    itotal: '',
  }];

  addAddress() {
    this.addinputs.push({
      dtution: '',
      dacademic: '',
      dtotal: '',
      itution: '',
      iacademic: '',
      itotal: '',
    });
  }

  removeAddress(i: number) {
    this.addinputs.splice(i, 1);
  } */

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/feebyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.feesForm.patchValue({
              _id: data.data._id,
              course: data.data.course,
              coursename: data.data.coursename,
              duration: data.data.duration,
              scholarship: data.data.scholarship,
              dtution_0 : data.data.dtution_1,
              dacademic_0 : data.data.dacademic_1,
              dtotal_0 : data.data.dtotal_1,
              itution_0 : data.data.itution_1,
              iacademic_0 : data.data.iacademic_1,
              itotal_0 : data.data.itotal_1,
              dtution_1 : data.data.dtution_2,
              dacademic_1 : data.data.dacademic_2,
              dtotal_1 : data.data.dtotal_2,
              itution_1 : data.data.itution_2,
              iacademic_1 : data.data.iacademic_2,
              itotal_1 : data.data.itotal_2,
              dtution_2 : data.data.dtution_3,
              dacademic_2 : data.data.dacademic_3,
              dtotal_2 : data.data.dtotal_3,
              itution_2 : data.data.itution_3,
              iacademic_2 : data.data.iacademic_3,
              itotal_2 : data.data.itotal_3,
              dtution_3 : data.data.dtution_4,
              dacademic_3 : data.data.dacademic_4,
              dtotal_3 : data.data.dtotal_4,
              itution_3 : data.data.itution_4,
              iacademic_3 : data.data.iacademic_4,
              itotal_3 : data.data.itotal_4,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
        data => {
          this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });

    this.feesForm = this.formBuilder.group({
      scholarship: [''],
      course: ['', Validators.required],
      duration: ['', [Validators.required,Validators.min(1),Validators.max(4)]],
      coursename: [''],
      dtution_0: [''],
      dacademic_0: [''],
      dtotal_0: [''],
      itution_0: [''],
      iacademic_0: [''],
      itotal_0: [''],
      dtution_1: [''],
      dacademic_1: [''],
      dtotal_1: [''],
      itution_1: [''],
      iacademic_1: [''],
      itotal_1: [''],
      dtution_2: [''],
      dacademic_2: [''],
      dtotal_2: [''],
      itution_2: [''],
      iacademic_2: [''],
      itotal_2: [''],
      dtution_3: [''],
      dacademic_3: [''],
      dtotal_3: [''],
      itution_3: [''],
      iacademic_3: [''],
      itotal_3: [''],
      _id: ['']
    })
  }

  get f() { return this.feesForm.controls; }

  getcourses(value){
    this.http.get<any>(this.api_endpoint+'/coursebyid/'+value).subscribe(
      data => {
        
        this.feesForm.patchValue({
          coursename: data.data.course,
        })
       
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.feesForm.invalid) {
      return;
    }

    
      // console.log(this.coursename);
    if(this.action == 'Submit'){

      

    var data = {
      "course" : this.feesForm.value.course,
      "scholarship" : this.feesForm.value.scholarship,
      "coursename" : this.feesForm.value.coursename,
      "duration" : this.feesForm.value.duration,
      "dtution_1" : this.feesForm.value.dtution_0,
      "dacademic_1" : this.feesForm.value.dacademic_0,
      "dtotal_1" : this.feesForm.value.dtotal_0,
      "itution_1" : this.feesForm.value.itution_0,
      "iacademic_1" : this.feesForm.value.iacademic_0,
      "itotal_1" : this.feesForm.value.itotal_0,
      "dtution_2" : this.feesForm.value.dtution_1,
      "dacademic_2" : this.feesForm.value.dacademic_1,
      "dtotal_2" : this.feesForm.value.dtotal_1,
      "itution_2" : this.feesForm.value.itution_1,
      "iacademic_2" : this.feesForm.value.iacademic_1,
      "itotal_2" : this.feesForm.value.itotal_1,
      "dtution_3" : this.feesForm.value.dtution_2,
      "dacademic_3" : this.feesForm.value.dacademic_2,
      "dtotal_3" : this.feesForm.value.dtotal_2,
      "itution_3" : this.feesForm.value.itution_2,
      "iacademic_3" : this.feesForm.value.iacademic_2,
      "itotal_3" : this.feesForm.value.itotal_2,
      "dtution_4" : this.feesForm.value.dtution_3,
      "dacademic_4" : this.feesForm.value.dacademic_3,
      "dtotal_4" : this.feesForm.value.dtotal_3,
      "itution_4" : this.feesForm.value.itution_3,
      "iacademic_4" : this.feesForm.value.iacademic_3,
      "itotal_4" : this.feesForm.value.itotal_3,
      "admin" : sessionStorage.getItem('adminName'),
    };
    console.log(data);
    
    this.http.post<any>(this.api_endpoint+'/fee', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/fees/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
    }else{
      var data1 = {
        "course" : this.feesForm.value.course,
        "coursename" : this.feesForm.value.coursename,
        "duratiion" : this.feesForm.value.duratiion,
        "scholarship" : this.feesForm.value.scholarship,
        "dtution_1" : this.feesForm.value.dtution_0,
        "dacademic_1" : this.feesForm.value.dacademic_0,
        "dtotal_1" : this.feesForm.value.dtotal_0,
        "itution_1" : this.feesForm.value.itution_0,
        "iacademic_1" : this.feesForm.value.iacademic_0,
        "itotal_1" : this.feesForm.value.itotal_0,
        "dtution_2" : this.feesForm.value.dtution_1,
        "dacademic_2" : this.feesForm.value.dacademic_1,
        "dtotal_2" : this.feesForm.value.dtotal_1,
        "itution_2" : this.feesForm.value.itution_1,
        "iacademic_2" : this.feesForm.value.iacademic_1,
        "itotal_2" : this.feesForm.value.itotal_1,
        "dtution_3" : this.feesForm.value.dtution_2,
        "dacademic_3" : this.feesForm.value.dacademic_2,
        "dtotal_3" : this.feesForm.value.dtotal_2,
        "itution_3" : this.feesForm.value.itution_2,
        "iacademic_3" : this.feesForm.value.iacademic_2,
        "itotal_3" : this.feesForm.value.itotal_2,
        "dtution_4" : this.feesForm.value.dtution_3,
        "dacademic_4" : this.feesForm.value.dacademic_3,
        "dtotal_4" : this.feesForm.value.dtotal_3,
        "itution_4" : this.feesForm.value.itution_3,
        "iacademic_4" : this.feesForm.value.iacademic_3,
        "itotal_4" : this.feesForm.value.itotal_3,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.feesForm.value._id,
      };
        // console.log(data1);     
        this.http.put<any>(this.api_endpoint+'/fee/', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/fees/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
